import React from 'react';

export default function StatCard({ title, value, icon, subtitle, change, trend = 'neutral' }) {
  const renderIcon = () => {
    if (!icon) return null;
    if (React.isValidElement(icon)) return icon;
    if (typeof icon === 'function' || typeof icon === 'object') {
      const IconComponent = icon;
      return <IconComponent size={22} />;
    }
    return null;
  };

  return (
    <div className="bg-slate-900/80 border border-slate-800/80 rounded-2xl p-5 hover:border-slate-700 transition-all duration-300 shadow-sm relative overflow-hidden group">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider">{title}</p>
          <h3 className="text-2xl sm:text-3xl font-extrabold text-white mt-2 tracking-tight">
            {value}
          </h3>
          {subtitle && (
            <p className="text-xs text-slate-400 mt-1 font-medium">{subtitle}</p>
          )}
        </div>
        <div className="w-12 h-12 rounded-xl bg-[#9BB7A3]/10 border border-[#9BB7A3]/20 flex items-center justify-center text-[#9BB7A3] group-hover:scale-110 transition-transform duration-300 shrink-0">
          {renderIcon()}
        </div>
      </div>
      {change && (
        <div className="mt-4 pt-3 border-t border-slate-800/60 flex items-center gap-2 text-xs font-medium">
          <span
            className={
              trend === 'up'
                ? 'text-emerald-400'
                : trend === 'down'
                ? 'text-rose-400'
                : 'text-slate-400'
            }
          >
            {change}
          </span>
        </div>
      )}
    </div>
  );
}
